module.exports = __webpack_public_path__ + "img/bancontact_pay.6fb221ea.svg";